import { Button, Image, List } from "antd";
import React from "react";
import { Modal, Space } from 'antd';
import { useState } from "react";
import Footer from "./Footer";
import globalService from "../utils";

const { sessionManage, } = globalService


const NewsListNotFree = () => {
    const [showQRCode, setShowQRCode] = useState(false);

    const newsList = [
        {
            img_src: "https://raymedy.cn:8089/news_image/b10.jpg",
            id: 1,
            title: "健康与疤痕",
            digest: "疤痕的影响还与我们的年龄有关系。当我们年轻时，经脉能量相对较强， 有动力穿过或绕行疤痕，但随着年纪的增长，经脉的能量降低，就会更加明显地影响能量和信息传输，这种瘀阻刚开始不会马上造成巨大的伤害，但是经过多年的积累就会对经脉和相关脏器造成重大影响，从而催生各种疾病。",
            price: 100,
            date: "2017-09-29 16:23",
        },
        {
            img_src: "https://raymedy.cn:8089/news_image/b5.jpg",
            id: 2,
            title: "慢病寻根",
            digest: "中医倡导治‘未病’，从经脉病理学来看，当某条经脉的能量（调节能力）不足或不平衡时，身体就会出现细微的变化，比如功能性的改变，这距离出现通常可以观察到的病症还有一段距离， 如果这种功能性的改变不被重视并加以改变，那么长久下去就会形成病症，我们知道，将疾病消除在这样的初始阶段比以后疾病完全形成后再治疗要容易得多，有效得多。 我们身体经脉系统具有极高的灵敏度， 能够在病症形成前就体现出身体状况的改变，从而为早期干预提供了保障。",
            price: 100,
            date: "2017-09-29 16:23",
        },
        {
            img_src: "https://raymedy.cn:8089/news_image/treatment.jpg",
            id: 3,
            title: "经脉平衡",
            digest: "每天24小时， 我们的身体总是一刻不停歇的运转，不断受到来自气候， 环境， 食物和各种情绪压力的干扰，每一次干扰，就是一次消耗，都会打破已有平衡，很多时候身体很难完全靠内在调节来恢复平衡，问题就会累积起来，需要借助外力帮助恢复平衡。",
            price: 100,
            date: "2017-09-29 16:23",
        },
        {
            img_src: "/news_profiles/profile_4.png",
            id: 4,
            title: "经脉测量",
            digest: "就如传统中医的描述，每条经脉都有其特定的一组功能。经脉影响着每一个生理系统和脏器，如：免疫，内分泌，循环，呼吸，消化，和淋巴系统等等。每个系统至少有一条经脉提供信息和能量，当某条经脉的能量缺少、受阻、出现异常时，便会危害到它所掌管的系统。经脉系统和血液系统同样重要，你的生命和健康仰仗这两者，缺一不可。这个系统非正式地命名为经脉测量。",
            price: 100,
            date: "2017-09-29 16:23",
        },
        {
            img_src: "/news_profiles/profile_5.png",
            id: 5,
            title: "选择润脉，紧跟大趋势",
            digest: "不确定性：它所带来的恐惧会强化和提高人们对风险管控的意识，并随之带来许多变化，这些变化可能是机会，也可能是挑战，看我们站在哪个角度去思考。",
            price: 100,
            date: "2017-09-29 16:23",
        },
        {
            img_src: "/news_profiles/profile_6.png",
            id: 6,
            title: "润脉的独特之处",
            digest: "润脉在这么多年的发展过程中，有一个全球和合作的团队，润脉的团队都是在相关领域的顶尖人物。Dr. Kia Saachi是伊朗中西医结合先驱，是德黑兰Miad Hospital.中西医整合分院的联合创始人之一。目前，他是伊朗科学针灸协会(ISAA) 的董事会成员。他为Raymedy提供了大量的临床数据和使用经验。",
            price: 100,
            date: "2017-09-29 16:23",

        },
        {
            img_src: "/news_profiles/profile_7.png",
            id: 7,
            title: "经脉学",
            digest: "如果我们从大的角度来说，如果我们讨论经脉学也好，或者你叫他经络学也好哈，经脉阿和络脉的这方面的，有研究的，能够看得到的，现在的研究哈，那个我确实没有看到专门关于洛买的这方面的研究那提到的都是，主要都是12对经脉。",
            price: 100,
            date: "2017-09-29 16:23",
        },
        {
            img_src: "/news_profiles/profile_8.png",
            id: 8,
            title: "实时靶向经脉调理",
            digest: "入门学习群的朋友你好，我是觉你我想今天，我们分享一下，就是关于润家宝APP里面的72个经脉调理方案简单的介绍一下，72个方案，为什么是72个金买调理方案，稍微做一下解释，主要是为了。",
            price: 100,
            date: "2017-09-29 16:23",
        },
        {
            img_src: "/news_profiles/profile_9.png",
            id: 9,
            title: "氧化压力",
            digest: "能量医学群的朋友晚上好，我是给你欢迎您收听今天的分享，而且我们一起呢，今天来学习一下关于这个氧化压力吧，就是我们先聊一聊什么叫抗氧化，因为这个已经是非常热门的一个词啊，尤其是在这个营养啊，喝这个保健品的市场。",
            price: 100,
            date: "2017-09-29 16:23",
        },
        {
            img_src: "/news_profiles/profile_10.png",
            id: 10,
            title: "抑郁请试试“光”的引领",
            digest: "对能量医学来说，任何的负面的情绪，只要情绪是持续的，都会累积，对你身体是有反应，的身体有一个自救的系统，种压力，情绪，身体是会从某一个脏器发生自我的调节的时候，脏器就会自己产生抵抗的能力，研究发现，通过大数据的对比",
            price: 100,
            date: "2017-09-29 16:23",
        }
    ];
    const TitleContent = ({ url, title, date, price, paied, onBuyButtonClick }) => (
        <Space direction="vertical" size={0}>
            {
                paied ? <a href={url}>{title}</a> :
                    <Space direction="horizontal" size={10}>
                        <span>{title}</span>
                        <Button type="primary" size="small" onClick={onBuyButtonClick}>
                            购买（{price}元/条）
                        </Button>
                    </Space>
            }
            <span style={{ color: '#999', fontSize: '12px' }}>{date}</span>
        </Space>
    );

    const handleBuyButtonClick = () => {
        // TODO: 应对审核，不管登录与否，直接显示二维码
        setShowQRCode(true);

        // const mobile = sessionManage.getItem('mobile');
        // if (!!mobile) {
        //     setShowQRCode(true);
        // } else {
        //     window.location.replace('/session');
        // }
    };

    return (
        <>
            <List itemLayout="vertical" dataSource={newsList} split
                renderItem={item => (
                    <List.Item
                        key={item.id}
                    >
                        <List.Item.Meta
                            avatar={<Image src={item.img_src}
                                wrapperStyle={{ width: "200px", height: "150px" }}
                                wrapperClassName="server"
                            />}
                            title={<TitleContent
                                title={item.title}
                                date={item.date}
                                price={item.price}
                                url={"/news2/" + item.id}
                                paied={item.paied}
                                onBuyButtonClick={handleBuyButtonClick} />}
                            description={item.digest}
                        />
                    </List.Item>
                )}
            >
            </List>
            <Modal centered width={321} visible={showQRCode} destroyOnClose footer={null}
                title="请使用支付宝扫码支付" onCancel={() => setShowQRCode(false)}>
                <Space>
                    <Image src="/alipay.jpeg" preview={false} />
                </Space>
            </Modal>
            <Footer />
        </>
    );
};

export default NewsListNotFree;